module.exports = __webpack_public_path__ + "img/acaki13.a0258b6e.jpg";